import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    timeout: 30000,
    withCredentials: true,
});

export const getChangelog = () => api.get("/changelog");

// Stock APIs
export const searchStocks = (q) => api.get(`/stocks/search?q=${encodeURIComponent(q)}`);
export const getMajorStocks = () => api.get("/stocks/major");
export const getStock = (symbol) => api.get(`/stocks/${symbol}`);
export const getStockHistory = (symbol, period = "3m") => api.get(`/stocks/${symbol}/history?period=${period}`);
export const getStockIndicators = (symbol) => api.get(`/stocks/${symbol}/indicators`);
export const analyzeStock = (symbol, context = "") => api.post(`/stocks/${symbol}/analyze`, { context });

// Market
export const getMarketOverview = () => api.get("/market/overview");

// Crypto
export const getTopCrypto = () => api.get("/crypto/top");
export const getCryptoHoldings = () => api.get("/crypto/holdings");
export const getCryptoChart = (coinId, days = 30) => api.get(`/crypto/${coinId}/chart?days=${days}`);

// Portfolio
export const getPortfolio = () => api.get("/portfolio");
export const getSeenHints = () => api.get("/auth/hints");
export const getAlerts = () => api.get("/alerts");
export const markAlertsSeen = (ids) => api.post("/alerts/seen", { ids });
export const markHintSeen = (key) => api.post(`/auth/hints/${key}`);
export const addToPortfolio = (item) => api.post("/portfolio", item);
export const removeFromPortfolio = (id) => api.delete(`/portfolio/${id}`);
export const updatePortfolioItem = (id, data) => api.put(`/portfolio/${id}`, data);
export const sellPosition = (id, sell_price, shares) => api.post(`/portfolio/${id}/sell`, { sell_price, shares });
export const getLimitOrders = (status = "open") => api.get(`/orders?status=${status}`);
export const createLimitOrder = (body) => api.post("/orders", body);
export const createEntryOrder = (body) => api.post("/entry-orders", body);
export const getEntryOrders = () => api.get("/entry-orders");
export const cancelEntryOrder = (id) => api.delete(`/entry-orders/${id}`);
export const cancelLimitOrder = (id) => api.delete(`/orders/${id}`);
export const getOrderNotifications = () => api.get("/orders/notifications");
export const markOrderNotificationsSeen = (ids) => api.post("/orders/notifications/seen", { ids });
export const getPortfolioValueHistory = (days = 90) => api.get(`/portfolio/value-history?days=${days}`);
export const getTradeHistory = () => api.get("/trades");
export const deleteTrade = (id) => api.delete(`/trades/${id}`);

// Watchlist
export const getWatchlist = () => api.get("/watchlist");
export const addToWatchlist = (item) => api.post("/watchlist", item);
export const removeFromWatchlist = (symbol) => api.delete(`/watchlist/${symbol}`);

// Woodrow
export const getOverseasMarkets = () => api.get("/woodrow/overseas");
export const analyzeOverseasOpportunities = () => api.post("/woodrow/overseas/analyze");
export const get52WeekHighsLows = () => api.get("/woodrow/52week");

// Woodrow Autonomous Trading
export const getWoodrowAccount = () => api.get("/woodrow/account");
export const getWoodrowTrades = () => api.get("/woodrow/account/trades");
export const woodrowRunNow = () => api.post("/woodrow/account/run-now");
export const woodrowReoptimize = () => api.post("/woodrow/account/reoptimize", {}, { timeout: 90000 });
export const woodrowReset = () => api.post("/woodrow/account/reset");
export const woodrowResume = () => api.post("/woodrow/account/resume");
export const getWoodrowPerformance = (period = "all", offset = 0) => {
    const tzOffset = new Date().getTimezoneOffset(); // minutes behind UTC (e.g., 240 for ET)
    return api.get(`/woodrow/account/performance?period=${period}&offset=${offset}&tz=${tzOffset}`);
};
export const getWoodrowBenchmark = (period = "all") => api.get(`/woodrow/benchmark?period=${period}`);
export const getWoodrowStrategy = () => api.get("/woodrow/strategy");
export const updateWoodrowStrategy = (data) => api.put("/woodrow/strategy", data);

// Health
export const checkHealth = () => api.get("/health");
export const getMarketStatus = () => api.get("/market/status");

export default api;
